<template>
  <div :id="idDelInput" class="contenedor-listado-cedulas">
    <div id="dimensiones-pantalla-tmp"></div>
    <table v-if="!mostrarLayoutCardView" id="tablaCedulas" class="table table-dark contenido-listado" style="width: 100%; heigth: 100%">
      <thead class="thead-dark">
        <tr>
          <th class="encabezados-listado text-center" v-for="(encabezado,index) in encabezadosColumnas" :key="'encabezado' + index" scope="col">{{encabezado}}</th>
          <th v-if="accionesEnTabla.check === true && listaDeCedulas.length > 0" class="align-middle encabezados-listado" style="width: 10px;">
            <div v-show="enableSelectAll" class="form-inline justify-content-center"><input :id="idDelInput + 'seleccionarTodos'" type="checkbox" @change="evtSeleccionarTodo($event)" class="form-check-input" title="Seleccionar todo"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cedula,index) in obtenerPaginacionDeCedulas" :key="'Archivo' + index">
          <td v-for="(columna,index) in obtenerCeldasTabla(cedula)" :class="definirAlineacion(index, cedula)" :key="'columna' + index" v-html="columna">columna</td>
          <td id="celda-acciones" v-if="accionesEnTabla.motrarAcciones === true" :class="[(resaltarFila.aplicarValidacion  && resaltarFila.validacion(index, cedula)) ? 'text-center align-middle resaltar-fila' : 'text-center align-middle']" :style="elegirAnchoCeldaAcciones()">                        
            <button v-if="accionesEnTabla.resultado === true && (cedula.Estatus === 'Parcialmente Finalizada' && cedula.FechaDeEnvioAJuzgado != null && (cedula.ResultadoParcialComplementado === false || cedula.ResultadoParcialComplementado === null))" :id="idDelInput + '-resultado-' + cedula.Folio" type="button" @click="accionesFuncionDeResultado($event)" class="btn-sm btn-primary base" title="Agregar Resultado"><i :id="idDelInput + '-resultado-' + cedula.Folio"  class="fas fa-list"></i></button>
            <button v-if="accionesEnTabla.editar === true" :id="idDelInput + '-editar-' + cedula.Folio" type="button" @click="accionesFuncionDeEditar($event)" class="btn-sm btn-primary editar" title="Editar"><i :id="idDelInput + '-editar-' + cedula.Folio"  class="fas fa-edit"></i></button>
            <button v-if="accionesEnTabla.editarCedula === true && sePuedeEditar(cedula)" :id="idDelInput + '-editar-' + cedula.Folio" type="button" @click="accionesFuncionDeEditar($event)" class="btn-sm btn-primary editar" title="Editar"><i :id="idDelInput + '-editar-' + cedula.Folio"  class="fas fa-edit"></i></button>
            <button v-if="accionesEnTabla.detalles === true" :id="idDelInput + '-detalles-' + cedula.Folio" type="button" @click="accionesFuncionDeDetalles($event)" class="btn-sm btn-primary base" title="Ver detalles"><i :id="idDelInput + '-detalles-' + cedula.Folio" class="fas fa-info-circle"></i></button>
            <button v-if="accionesEnTabla.imprimir === true" :id="idDelInput + '-imprimir-' + cedula.Folio" type="button" @click="accionesFuncionDeImprimir($event)" class="btn-sm btn-primary base" title="Imprimir"><i :id="idDelInput + '-imprimir-' + cedula.Folio" class="fas fa-print"></i></button>
            <button v-if="accionesEnTabla.ver === true" :id="idDelInput + '-ver-' + cedula.Folio" type="button" @click="accionesFuncionDeVer($event)" class="btn-sm btn-primary base" title="Ver"><i :id="idDelInput + '-ver-' + cedula.Folio" class="fas fa-eye"></i></button>
            <button v-if="accionesEnTabla.eliminar === true" :id="idDelInput + '-eliminar-' + cedula.Folio" type="button" @click="accionesFuncionDeEliminar($event)" class="btn-sm btn-primary eliminar" title="Eliminar"><i :id="idDelInput + '-eliminar-' + cedula.Folio" class="fas fa-trash-alt"></i></button>
            <button v-if="accionesEnTabla.documento === true" :id="idDelInput + '-documento-' + cedula.Folio" type="button" @click="accionesFuncionDescargarDocumento(cedula)" class="btn-sm btn-primary" title="Descargar documento de cedula"><i :id="idDelInput + '-documento-' + cedula.Folio" class="fas fa-file-download"></i></button>
            <!-- <button v-if="accionesEnTabla.eliminar === true" :id="idDelInput + '-eliminar-' + cedula.Folio" type="button" @click="accionesFuncionDeEliminar($event)" class="btn-sm btn-primary"><i :id="idDelInput + '-eliminar-' + cedula.Folio" class="fas fa-trash-alt"></i></button> -->
            <button v-if="accionesEnTabla.constituir === true" :id="idDelInput + '-constitucion-' + cedula.Folio" type="button" @click="accionesFuncionConstitucion($event)" class="ml-3 btn btn-primary w-70 base"><i :id="idDelInput + '-constituir-' + cedula.Folio" class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Constituir</button>
            <button v-if="accionesEnTabla.cambiarArea === true" :id="idDelInput + '-cambiarArea-' + cedula.Folio" type="button" @click="accionesFuncionCambiarArea($event)" class="btn-sm btn-primary w-70 editar" title="Cambiar área encargada"><i :id="idDelInput + '-cambiarArea-' + cedula.Folio" class="fas fa-exchange-alt"></i></button>
            <button v-if="mostrarFuncionAgregar(cedula)" :id="idDelInput + '-agregar-' + cedula.Folio" type="button" @click="accionesFuncionDeAgregar($event)" class="btn btn-primary w-70 base" title="Agregar"><i :id="idDelInput + '-agregar-' + cedula.Folio" class="fas fa-plus-circle"></i></button>
            <button v-if="mostrarOpcActualizarDocumento(cedula)" :id="idDelInput + '-actualizarDocumento-' + cedula.Folio" type="button" @click="accionesFuncionActualizarDocumento($event, cedula)" class="btn btn-primary w-70 base" title="actualizarDocumento"><i :id="idDelInput + '-actualizarDocumento-' + cedula.Folio" class="fas fa-file-upload"></i></button>
            <button v-if="accionesEnTabla.elegir === true" :id="idDelInput + '-seleccionar-' + cedula.Folio" type="button" @click="accionesFuncionElegir($event)" class="btn btn-primary w-70 base" title="Seleccionar"><i :id="idDelInput + '-seleccionar-' + cedula.Folio" class="fas fa-mouse-pointer"></i></button>
          </td>
          <td v-if="accionesEnTabla.check === true" :class="[(resaltarFila.aplicarValidacion  && resaltarFila.validacion(index, cedula)) ? 'align-middle resaltar-fila' : 'align-middle']" style="width: 10px;">
            <div class="form-inline justify-content-center"><input :id="idDelInput + 'check' + cedula.Folio" type="checkbox" class="form-check-input" @change="seleccionDeCedula($event)" title="Seleccionar"></div>
          </td>
          <td v-if="accionesEnTabla.radio === true" :class="[(resaltarFila.aplicarValidacion  && resaltarFila.validacion(index, cedula)) ? 'resaltar-fila' : '']">
              <input :id="'radio' + cedula.Folio" type="radio" class="form-check-input" @change="evtSeleccionRadio(cedula)">
          </td>  
         <!--  <td v-if="accionesEnTabla.detalles === true" class="text-center mx-auto">
            <button :id="idDelInput + '-detalles-' + cedula.Folio" type="button" @click="accionesFuncionDeDetalles($event)" class="btn-sm btn-primary"><i :id="idDelInput + '-detalles-' + cedula.Folio" class="fas fa-info-circle"></i></button>
          </td> -->
        </tr>
        <tr class="no-data" v-if="listaDeCedulas == null || listaDeCedulas == undefined || listaDeCedulas.length < 1">
          <td :colspan="(encabezadosColumnas != null) ? encabezadosColumnas.length : 1" style="text-align: center"><i class="far fa-folder-open"></i>&nbsp;&nbsp;No se encontraron registros</td>
        </tr>
      </tbody>
    </table>
    <!-- CARD LAYOUT -->
    <div v-if="conResponsive && mostrarLayoutCardView" id="contendor-card-view">
      <div class="fila-card-layout" v-for="(cedula,index) in obtenerPaginacionDeCedulas" :key="'Archivo' + index">
        <!-- FILA PARA CHECKBOX DE SELECCION -->
        <div v-if="accionesEnTabla.check === true && listaDeCedulas.length > 0" class="row no-gutters">
          <div id="encabezados-card-view" class="col-3 padding-fila-card-layout">
            <div v-if="index < 1" class="form-inline justify-content-start" style="white-space: nowrap;">
              <input :id="idDelInput + 'seleccionarTodos'" type="checkbox" @change="evtSeleccionarTodo($event)"  title="Seleccionar todo">
            </div>
          </div>
          <div id="columnas-card-view" class="col-9 padding-fila-card-layout">
            <div class="form-inline justify-content-start" style="white-space: nowrap;">
              <input :id="idDelInput + 'check' + cedula.Folio" type="checkbox" @change="seleccionDeCedula($event)" title="Seleccionar">
            </div>
          </div>
        </div>
        <!-- COLUMNAS Y CAMPOS DE CEDULA -->
        <div class="row no-gutters" v-for="(columna,indexCelda) in obtenerCeldasTabla(cedula)" :key="'columna' + indexCelda">
          <div id="encabezados-card-view" class="col-3 padding-fila-card-layout">
            <div :class="[(campoRequeridoEsValido(encabezadosColumnas[indexCelda])) ? '' : 'ocultar-columna']">{{ campoRequeridoEsValido(encabezadosColumnas[indexCelda]) ? encabezadosColumnas[indexCelda] : 'Vacio' }}</div>
          </div>
          <div id="columnas-card-view" class="col-9 padding-fila-card-layout">
            <div :class="definirAlineacion(indexCelda, cedula)"  v-html="columna" style="text-align: left !important;"></div>
          </div>
        </div>
        <!-- ACCIONES -->
        <div class="row no-gutters">
          <div id="encabezados-card-view" class="col-3 padding-fila-card-layout">
            Acciones
          </div>
          <div id="columnas-card-view" class="col-9 padding-fila-card-layout">
            <div id="celda-acciones" v-if="accionesEnTabla.motrarAcciones === true" class="text-left align-middle" :style="elegirAnchoCeldaAcciones()">                        
              <button v-if="accionesEnTabla.resultado === true && (cedula.Estatus === 'Parcialmente Finalizada' && cedula.FechaDeEnvioAJuzgado != null && (cedula.ResultadoParcialComplementado === false || cedula.ResultadoParcialComplementado === null))" :id="idDelInput + '-resultado-' + cedula.Folio" type="button" @click="accionesFuncionDeResultado($event)" class="btn-sm btn-primary base" title="Agregar Resultado"><i :id="idDelInput + '-resultado-' + cedula.Folio"  class="fas fa-list"></i></button>
              <button v-if="accionesEnTabla.editar === true" :id="idDelInput + '-editar-' + cedula.Folio" type="button" @click="accionesFuncionDeEditar($event)" class="btn-sm btn-primary editar" title="Editar"><i :id="idDelInput + '-editar-' + cedula.Folio"  class="fas fa-edit"></i></button>
              <button v-if="accionesEnTabla.editarCedula === true && sePuedeEditar(cedula)" :id="idDelInput + '-editar-' + cedula.Folio" type="button" @click="accionesFuncionDeEditar($event)" class="btn-sm btn-primary editar" title="Editar"><i :id="idDelInput + '-editar-' + cedula.Folio"  class="fas fa-edit"></i></button>
              <button v-if="accionesEnTabla.detalles === true" :id="idDelInput + '-detalles-' + cedula.Folio" type="button" @click="accionesFuncionDeDetalles($event)" class="btn-sm btn-primary base" title="Ver detalles"><i :id="idDelInput + '-detalles-' + cedula.Folio" class="fas fa-info-circle"></i></button>
              <button v-if="accionesEnTabla.imprimir === true" :id="idDelInput + '-imprimir-' + cedula.Folio" type="button" @click="accionesFuncionDeImprimir($event)" class="btn-sm btn-primary base" title="Imprimir"><i :id="idDelInput + '-imprimir-' + cedula.Folio" class="fas fa-print"></i></button>
              <button v-if="accionesEnTabla.ver === true" :id="idDelInput + '-ver-' + cedula.Folio" type="button" @click="accionesFuncionDeVer($event)" class="btn-sm btn-primary base" title="Ver"><i :id="idDelInput + '-ver-' + cedula.Folio" class="fas fa-eye"></i></button>
              <button v-if="accionesEnTabla.eliminar === true" :id="idDelInput + '-eliminar-' + cedula.Folio" type="button" @click="accionesFuncionDeEliminar($event)" class="btn-sm btn-primary eliminar" title="Eliminar"><i :id="idDelInput + '-eliminar-' + cedula.Folio" class="fas fa-trash-alt"></i></button>
              <button v-if="accionesEnTabla.documento === true" :id="idDelInput + '-documento-' + cedula.Folio" type="button" @click="accionesFuncionDescargarDocumento(cedula)" class="btn-sm btn-primary" title="Descargar documento de cedula"><i :id="idDelInput + '-documento-' + cedula.Folio" class="fas fa-file-download"></i></button>
              <!-- <button v-if="accionesEnTabla.eliminar === true" :id="idDelInput + '-eliminar-' + cedula.Folio" type="button" @click="accionesFuncionDeEliminar($event)" class="btn-sm btn-primary"><i :id="idDelInput + '-eliminar-' + cedula.Folio" class="fas fa-trash-alt"></i></button> -->
              <button v-if="accionesEnTabla.constituir === true" :id="idDelInput + '-constitucion-' + cedula.Folio" type="button" @click="accionesFuncionConstitucion($event)" class="ml-3 btn btn-primary w-70 base"><i :id="idDelInput + '-constituir-' + cedula.Folio" class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Constituir</button>
              <button v-if="accionesEnTabla.cambiarArea === true" :id="idDelInput + '-cambiarArea-' + cedula.Folio" type="button" @click="accionesFuncionCambiarArea($event)" class="btn-sm btn-primary w-70 editar" title="Cambiar área encargada"><i :id="idDelInput + '-cambiarArea-' + cedula.Folio" class="fas fa-exchange-alt"></i></button>
              <button v-if="mostrarFuncionAgregar(cedula)" :id="idDelInput + '-agregar-' + cedula.Folio" type="button" @click="accionesFuncionDeAgregar($event)" class="btn btn-primary w-70 base" title="Agregar"><i :id="idDelInput + '-agregar-' + cedula.Folio" class="fas fa-plus-circle"></i></button>
              <button v-if="mostrarOpcActualizarDocumento(cedula)" :id="idDelInput + '-actualizarDocumento-' + cedula.Folio" type="button" @click="accionesFuncionActualizarDocumento($event, cedula)" class="btn btn-primary w-70 base" title="actualizarDocumento"><i :id="idDelInput + '-actualizarDocumento-' + cedula.Folio" class="fas fa-file-upload"></i></button>
              <button v-if="accionesEnTabla.elegir === true" :id="idDelInput + '-seleccionar-' + cedula.Folio" type="button" @click="accionesFuncionElegir($event)" class="btn btn-primary w-70 base" title="Seleccionar"><i :id="idDelInput + '-seleccionar-' + cedula.Folio" class="fas fa-mouse-pointer"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN CARD LAYOUT -->
    <nav :id="idDelInput + 'paginacion-tabla'" class="scroll-horizontal">
      <ul class="pagination justify-content-end scroll-horizontal">
        <li class="page-item">
          <button id="opcionPrimero" type="button" class="page-link" @click="cambioPrimerPagina" v-if="!paginacionTmp.some(p => p == 1) && (numeroDePaginas.length > limitePaginacion)"> Primero </button>
        </li>
        <li class="page-item">
          <button id="opcionInicio" type="button" class="page-link" v-if="pagina != 1" @click="cambioDePaginaConOpcion($event)"> Anterior </button>
        </li>
        <!-- <li :id="'pagina'+numeroDePagina" class="page-item" v-for="(numeroDePagina,index) in numeroDePaginas.slice(pagina-1, pagina+5)" :key="'pagina' + index"> -->
        <li :id="idDelInput + 'pagina'+numeroDePagina" class="page-item" v-for="(numeroDePagina,index) in numeroPaginasMostrar" :key="'pagina' + index">
          <button type="button" class="page-link active" @click="cambioDePaginaConPuntero(numeroDePagina)"> {{numeroDePagina}} </button>
        </li>
        <li class="page-item">
          <button id="opcionSiguiente" type="button" @click="cambioDePaginaConOpcion($event)" v-if="pagina < numeroDePaginas.length" class="page-link"> Siguiente </button>
        </li>
        <li class="page-item">
          <button id="opcionUltimo" type="button" class="page-link" @click="cambioUltimaPagina" v-if="!paginacionTmp.some(p => p == numeroDePaginas.length) && (numeroDePaginas.length > limitePaginacion)"> Ultimo </button>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'

  export default {
     components: {
       enumeraciones
     },
    props: {
      enableSelectAll: {
        type: Boolean,
        default: true
      },
      idDelInput: String,
      encabezadosColumnas: Array,
      alineacionesColumnas: Array,
      listaDeCedulas: Array,
      accionesEnTabla: Object,
      listaCedulasSeleccionadas: Array,      
      limitePaginacion: {
        type: Number,
        default: 10
      },
      limpiarSeleccionarTodo: {
        type: Boolean,
        default: false
      },
      /* PARA PODER UTILIZAR ESTA FUNCION SE TIENE QUE PASAR UN APROPIRDAD EN EL OBEJTO DE NOMBRE rutaDeDocumento utilizado
      en la funcion mostrarFuncionAgregar */
      permitirActualizarDocumentos: {
        type: Boolean,
        default: false
      },
      conResponsive: {
        type: Boolean,
        default: false
      },
      resaltarFila: {
        type: Object,
        default: () => ({ 
            aplicarValidacion: false,
            validacion: (index, valor) => false
        })
      }
    },
    data() {
      return {
        pagina: 1,
        numeroDePaginas: [],
        cedulasPaginadas: [],
        cedulasAmostrarPorPagina: 5,
        cedulasAEnviar: [],
       /*  limitePaginacion: 4, */
        paginacionTmp: [],
        seleccionarTodo: false,
        usuario:{
          area: null
        },
        mostrarLayoutCardView: false,
        radioSeleccionado: null
      }
    },
    methods: {
      accionesFuncionDescargarDocumento: function(elemento) {
        this.$emit("obtenerDocumento",elemento);
      },
      actualizarFila: function(objetoFila) { debugger
        const INDEX_FILA = this.listaDeCedulas.findIndex(c => c.Folio == objetoFila.Folio);
        this.listaDeCedulas[INDEX_FILA] = objetoFila;
      },
      evtSeleccionRadio: function(elementoSeleccionado) {
        this.$emit("accionRadioSeleccionado", elementoSeleccionado);
        this.radioSeleccionado = elementoSeleccionado;
        this.mostrarEstadoRadio({ idElemento: elementoSeleccionado.Folio });
      },
      definirAlineacion: function(index, valor = null){   
        let cssResaltarFila = (this.resaltarFila.aplicarValidacion  && this.resaltarFila.validacion(index, valor)) ? ' resaltar-fila' : '';
        if(this.alineacionesColumnas != undefined && this.alineacionesColumnas.length > 0){
          if(this.alineacionesColumnas[index] != undefined)
            return this.alineacionesColumnas[index] + cssResaltarFila
          else
            return "text-center align-middle" + cssResaltarFila;   
        }else{
          return "text-center align-middle" + cssResaltarFila;
        }
      },
      mostrarFuncionAgregar: function(cedula) {
        let mostrar = this.accionesEnTabla.agregar === true;
        if(this.permitirActualizarDocumentos) {
          const { rutaDeDocumento } = cedula;
          const ES_ACTUALIZACION = (rutaDeDocumento != null && rutaDeDocumento != undefined);
          mostrar = !ES_ACTUALIZACION;
        }
        return mostrar;
      },
      accionesFuncionActualizarDocumento: function(evento, cedula) {
        this.$emit("accionesFuncionaActualizarDoc", evento, cedula);
      },
      mostrarOpcActualizarDocumento: function(cedula) { 
        let mostrar = false;
        if(cedula.rutaDeDocumento != null && cedula.rutaDeDocumento != undefined) {
          mostrar = true;
        }
        return mostrar;
      },
      datosUsuario: function(areaDeUsuario){                   
        this.usuario.area = areaDeUsuario;          
      },
      sePuedeEditar: function(cedula){ 
        if(this.usuario.area.AreaId != null && this.usuario.area.AreaId != undefined) {
          /*  if(this.usuario.area.AreaId == enumeraciones.sinoj.juzgadosMixtos.Calvillo || 
             
            //this.usuario.area.AreaId == enumeraciones.sinoj.juzgadosMixtos.Pabellon || 
            this.usuario.area.AreaId == enumeraciones.sinoj.juzgadosMixtos.RinconDeRomos)
          { //Si es mixto
          let t = cedula.Jurisdiccion.AreasDeJurisdiccion.some(jur => jur.AreaId == this.usuario.area.AreaId);
            if(cedula.Jurisdiccion.AreasDeJurisdiccion.some(jur => jur.AreaId == this.usuario.area.AreaId))
              return true;
            else
              return false;
          }else*/
          if(cedula.Estatus === 'Creada' || cedula.Estatus === 'Regresada' || cedula.Estatus === 'Incompleta')
            return true;
        }
                                 
      },
      obtenerCeldasTabla: function(objeto) { 
        let elmentosModificados = [];
        let elementos = Object.values(objeto);
        let numeroValidoDeElementos = ((this.accionesEnTabla != null && this.accionesEnTabla != undefined) && Object.values(this.accionesEnTabla).some(a => a)) ? (this.encabezadosColumnas.length -1) : this.encabezadosColumnas.length;
        if(elementos.length > numeroValidoDeElementos) {
          for(let i=0; i< numeroValidoDeElementos; i++) {
            elmentosModificados.push(elementos[i]);
          }
        }
        else {
          elmentosModificados = elementos;
        }
        return elmentosModificados;
      },
      /**
       * funciones para obtener evento de acciones
       * @param {object} evento [evento emitido para el componente padre]
       * @see {@link #idDelInput}
       */
      accionesFuncionDeAgregar: function(evento) {
        this.$emit("accionFuncionAgregar", evento);
      },
      accionesFuncionElegir: function(evento) {
        this.$emit("accionesFuncionElegir", evento);
      },
      accionesFuncionConstitucion: function(evento) {
        this.$emit("accionFuncionConstitucion", evento);
      },
      accionesFuncionCambiarArea: function(evento){
        this.$emit("accionCambiarArea", evento);
      },
      accionesFuncionDeEliminar: function (evento) {
        this.$emit("accionFuncionEliminar", evento);
      },
      accionesFuncionDeDetalles: function (evento) {
        this.$emit("accionFuncionDetalles", evento);
      },
      accionesFuncionDeEditar: function (evento) {
          this.$emit("accionesFuncionDeEditar", evento);
      },
      accionesFuncionDeResultado: function (evento) {
          this.$emit("accionesFuncionDeResultado", evento);
      },
      accionesFuncionDeImprimir: function(evento) {
        this.$emit("accionesFuncionDeImprimir", evento);
      },
      accionesFuncionDeVer: function(evento) {
        this.$emit("accionesFuncionDeVer", evento);
      },
      evtSeleccionarTodo: function(evento) {
        const CHECKBOX_SELECCIONADO = evento.target.getAttribute('id');
        const SELECCIONADA = $('#' + CHECKBOX_SELECCIONADO).is(":checked");
        this.seleccionarTodo = SELECCIONADA;
        this.cedulasAEnviar = this.cedulasAEnviar.map(c => {
          c.enviar = SELECCIONADA;
          return c;
        });
        this.$nextTick(() => {
          this.mostrarEstadoCheckbox();
        });
        this.$emit("seleccionarTodo", SELECCIONADA);
        this.$emit("elementosSeleccionados", this.cedulasAEnviar);
      },
      /**
       * funcion para limpiar los elementos selccionados desde el componente padre
       */
      evtLimpiarSeleccionCPadre: function() {
        const SELECCIONADA = false;
        this.seleccionarTodo = false;
        this.cedulasAEnviar = this.cedulasAEnviar.map(c => {
          c.enviar = SELECCIONADA;
          return c;
        });
        this.$nextTick(() => {
          this.mostrarEstadoCheckbox();
        });
      },
      /**
       * funcion para convertir un objeto en arreglo
       * @param {object} objeto [objeto que se desea obtener sus valores en un arreglo]
       */
      obtenerNumeroDeColumnas: function (objeto) {
        let numeroDeColunmas = Object.values(objeto);
        return numeroDeColunmas;
      },
      /**
       * funcion encargada de registrar si una cedula es seleccionada en la lista,
       * @see {@link crearRegistroDeCedulasSeleccionadas}
       * @param {object} evento [evento change de input check]
       */
      seleccionDeCedula: function (evento) { 
        const CHECKBOX_SELECCIONADO = evento.target.getAttribute('id');
        const SELECCIONADA = $('#' + CHECKBOX_SELECCIONADO).is(":checked")
        const CEDULA = this.cedulasAEnviar.findIndex(c => c.idCheck == CHECKBOX_SELECCIONADO);
        console.log('cedulasEnviar::', this.cedulasAEnviar);
        console.log('SELECCIONADA::' + CHECKBOX_SELECCIONADO);
        this.cedulasAEnviar[CEDULA].enviar = SELECCIONADA;
        this.$emit("elementoSeleccionado", this.cedulasAEnviar[CEDULA]);
        this.$emit("elementosSeleccionados", this.cedulasAEnviar);
        if(!this.cedulasAEnviar.some(c => c.enviar)) {
            this.$nextTick(() => {
              this.seleccionarTodo = false;
              $("#" + this.idDelInput + 'seleccionarTodos').prop('checked', false);
            });
        }
      },
      seleccionDeCedulaComponentePadre: function (idCedulaSeleccionada) { 
        this.$nextTick(() => {
            $("#" + idCedulaSeleccionada).prop('checked', true);
            const CEDULA = this.cedulasAEnviar.findIndex(c => c.idCheck == idCedulaSeleccionada);
            this.cedulasAEnviar[CEDULA].enviar = true;
        });
      },
      mostrarSeleccionTodoComponentePadre: function(mostrarSeleccionarTodo) {
        this.$nextTick(() => {
           if(mostrarSeleccionarTodo) {
              $("#" + this.idDelInput + 'seleccionarTodos').prop('checked', true); 
              this.seleccionarTodo = true;
           }
           else {
              $("#" + this.idDelInput + 'seleccionarTodos').prop('checked', false);
              this.seleccionarTodo = false;
           }
        });
      },
      /**
       * funcion encargada de mostrar los input check habilitados en base al renderizado
       * de la paginacion de la tabla.
       */
      mostrarEstadoCheckbox: function () {
        $("#" + this.idDelInput + " input[type='checkbox']").prop('checked', false);
        this.cedulasAEnviar.filter(c => c.enviar).forEach((check) => {
          $("#" + check.idCheck).prop('checked', true);
        });
        if(this.seleccionarTodo)
          $("#" + this.idDelInput + 'seleccionarTodos').prop('checked', true);
      },
      mostrarEstadoRadio: function ({ idElemento }) {
        this.$nextTick(() => {
          $("#" + this.idDelInput + " input[type='radio']").prop('checked', false);
          $("#radio" + idElemento).prop('checked', true);
        });
      },
      seleccionarTodosRadio: function () {
        this.$nextTick(() => {
          $("#" + this.idDelInput + " input[type='radio']").prop('checked', true);
        });
      },
      /**
       * funcion encargada de obtener la primer pagina
       */
      cambioPrimerPagina: function() { 
        this.pagina = 1;
        let nuevaPaginacionTmp = [];
        if(this.numeroDePaginas.length > this.limitePaginacion) {
          for(let i=1; i<=this.limitePaginacion; i++) {
            nuevaPaginacionTmp.push(i);
          }
          this.paginacionTmp = nuevaPaginacionTmp;
        }
        this.$nextTick(() => {
          this.mostrarEstadoCheckbox();
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li").removeClass('active');
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li button").unbind('mouseenter').unbind('mouseleave');
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li button").blur(); 
          $("#" + this.idDelInput + 'pagina' + this.pagina).addClass('active');
          if(this.radioSeleccionado != null)
            this.mostrarEstadoRadio({ idElemento: this.radioSeleccionado.Folio });
        });
      },
       /**
       * funcion encargada de obtener la ultima pagina
       */
      cambioUltimaPagina: function() {
        this.pagina = this.numeroDePaginas.length;
        let nuevaPaginacionTmp = [];
        let inicioPaginacion = (this.numeroDePaginas.length - this.limitePaginacion);
        for(let i = (inicioPaginacion + 1); i <= this.numeroDePaginas.length; i++) {
          nuevaPaginacionTmp.push(i);
        }
        this.paginacionTmp = nuevaPaginacionTmp;
        this.$nextTick(() => {
          this.mostrarEstadoCheckbox();
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li").removeClass('active');
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li button").unbind('mouseenter').unbind('mouseleave');
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li button").blur(); 
          $("#" + this.idDelInput + 'pagina' + this.pagina).addClass('active');
          if(this.radioSeleccionado != null)
            this.mostrarEstadoRadio({ idElemento: this.radioSeleccionado.Folio });
        });
      },
      /**
      * funcion encargada de realizar el desplazamiento con las opciones de siguiente o anterior.
      * @param {object} evento [evento click opcion(siguiente o anterior)]
      */
      cambioDePaginaConOpcion: function (evento) { 
        const SELECCION_ID = evento.target.getAttribute('id');
        const ANTERIOR_ID = 'opcionInicio';
        const SIGUIENTE_ID = 'opcionSiguiente';

        if (SELECCION_ID === ANTERIOR_ID) {
          if(this.limitePaginacion < this.numeroDePaginas.length) {
            let numeroDePaginasMostrar = (this.pagina - this.limitePaginacion); // modificacion
            this.pagina--;
            // modificacion
            if(numeroDePaginasMostrar > 0) {
              let nuevaPaginacionTmp = [];
              for(let i = numeroDePaginasMostrar; i <= this.pagina; i++) {
                nuevaPaginacionTmp.push(i);
              }
              this.paginacionTmp = nuevaPaginacionTmp;
            }
            else {
              let nuevaPaginacionTmp = [];
              for(let i = 1; i <= this.limitePaginacion; i++) {
                nuevaPaginacionTmp.push(i);
              }
              this.paginacionTmp = nuevaPaginacionTmp;
            }
            // modificacion
          }
          else {
            this.pagina--;
          }
        }
        else if (SELECCION_ID === SIGUIENTE_ID) {
          if(this.limitePaginacion < this.numeroDePaginas.length) {
            let numeroDePaginasMostrar = (this.pagina + this.limitePaginacion); // modificacion
            this.pagina++;
            // modificacion
            if(numeroDePaginasMostrar <= this.numeroDePaginas.length) {
              let nuevaPaginacionTmp = [];
              for(let i = this.pagina; i <= numeroDePaginasMostrar; i++) {
                nuevaPaginacionTmp.push(i);
              }
              this.paginacionTmp = nuevaPaginacionTmp;
            }
            else {
              let nuevaPaginacionTmp = [];
              let inicioPaginacion = (this.numeroDePaginas.length - this.limitePaginacion);
              for(let i = (inicioPaginacion + 1); i <= this.numeroDePaginas.length; i++) {
                nuevaPaginacionTmp.push(i);
              }
              this.paginacionTmp = nuevaPaginacionTmp;
            }
            // modificacion
          }
          else {
            this.pagina++;
          }
        }
        this.$nextTick(() => {
          this.mostrarEstadoCheckbox();
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li").removeClass('active');
          $("#" + this.idDelInput + 'pagina' + this.pagina).addClass('active');
          if(this.radioSeleccionado != null)
            this.mostrarEstadoRadio({ idElemento: this.radioSeleccionado.Folio });
        });
      },
      /**
      * funcion encargada de realizar el desplazamiento mediante click directo sobre el numero de pagina.
      * @param {object} numeroDePagina [valor de pagina para realizar la paginacion]
      */
      cambioDePaginaConPuntero: function (numPag) { 
        if(this.limitePaginacion < this.numeroDePaginas.length) {
          if (numPag < this.pagina) {
            this.pagina = numPag;
            let numeroDePaginasMostrar = (this.pagina - this.limitePaginacion); // modificacion
            // modificacion
            if(numeroDePaginasMostrar > 0) {
              let nuevaPaginacionTmp = [];
              for(let i = (numeroDePaginasMostrar + 1); i <= this.pagina; i++) {
                nuevaPaginacionTmp.push(i);
              }
              this.paginacionTmp = nuevaPaginacionTmp;
            }
            else {
              let nuevaPaginacionTmp = [];
              for(let i = 1; i <= this.limitePaginacion; i++) {
                nuevaPaginacionTmp.push(i);
              }
              this.paginacionTmp = nuevaPaginacionTmp;
            }
            // modificacion
          }
          else if (numPag > this.pagina) {
            this.pagina = numPag;
            let numeroDePaginasMostrar = (this.pagina + this.limitePaginacion); // modificacion
            // modificacion
            if(numeroDePaginasMostrar <= this.numeroDePaginas.length) {
              let nuevaPaginacionTmp = [];
              for(let i = this.pagina; i < numeroDePaginasMostrar; i++) {
                nuevaPaginacionTmp.push(i);
              }
              this.paginacionTmp = nuevaPaginacionTmp;
            }
            else {
              let nuevaPaginacionTmp = [];
              let inicioPaginacion = (this.numeroDePaginas.length - this.limitePaginacion);
              for(let i = (inicioPaginacion + 1); i <= this.numeroDePaginas.length; i++) {
                nuevaPaginacionTmp.push(i);
              }
              this.paginacionTmp = nuevaPaginacionTmp;
            }
            // modificacion
          }
        }
        else {
          this.pagina = numPag;
        }
        this.$nextTick(() => {
          this.mostrarEstadoCheckbox();
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li").removeClass('active');
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li button").unbind('mouseenter').unbind('mouseleave');
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li button").blur(); 
          $("#" + this.idDelInput + 'pagina' + this.pagina).addClass('active');
          if(this.radioSeleccionado != null)
            this.mostrarEstadoRadio({ idElemento: this.radioSeleccionado.Folio });
        });
      },
      /**
      * funcion encargada de obtener el numero de paginas en base a una fuente de datos dividido entre
      * el numero de registros que se desea mostrar por paginacion en la tabla.
      * @see {@link listaDeCedulas}
      * @see {@link cedulasAmostrarPorPagina}
      */
      obtenerNumeroDePaginas: function () { 
        let numeroDePaginas = Math.ceil(this.listaDeCedulas.length / this.cedulasAmostrarPorPagina);
        this.numeroDePaginas = [];
        this.pagina = 1;
        this.cedulasAEnviar = [];
        this.paginacionTmp = [];
        for (let i = 1; i <= numeroDePaginas; i++) {
          this.numeroDePaginas.push(i);
        }
        // modicacion
        if(numeroDePaginas > this.limitePaginacion) {
          for(let i=1; i<=this.limitePaginacion; i++) {
            this.paginacionTmp.push(i);
          }
        }
        else {
          this.paginacionTmp = this.numeroDePaginas;
        }
        // termina modificacion
        this.$nextTick(() => {
          $("#" + this.idDelInput + 'paginacion-tabla ' + "li").removeClass('active');
          $("#" + this.idDelInput + 'pagina' + this.pagina).addClass('active');
        });
        this.crearRegistroDeCedulasSeleccionadas();
        this.mostrarEstadoCheckbox();
        if(this.radioSeleccionado != null)
            this.mostrarEstadoRadio({ idElemento: this.radioSeleccionado.Folio });
      },
      /**
       * funcion encargada de filtrar el numero de registros en base al tipo de pagina seleccionada
       * regresando los registros que se encuentren en ese rango.
       * @see {@link listaDeCedulas}
       * @returns {Array} listaDeCedulas [lista de cedulas encontradas con los valores de la paginacion]
       */
      paginacionDeCedulas: function (listaDeCedulas) {
        let pagina = this.pagina;
        let cedulasAmostrarPorPagina = this.cedulasAmostrarPorPagina;
        let desde = (pagina * cedulasAmostrarPorPagina) - cedulasAmostrarPorPagina;
        let hasta = (pagina * cedulasAmostrarPorPagina);
        return listaDeCedulas.slice(desde, hasta);
      },
      /**
       * funcion encargada de crear una lista con las cedulas seleccionadas utilizando como identificador el numero de folio
       * de la cedula
       */
      crearRegistroDeCedulasSeleccionadas: function () {
        this.cedulasAEnviar = [];
        this.listaDeCedulas.forEach(cedula => {
          let cedulaAEnviar = {
            idCheck: (this.idDelInput + 'check' + cedula.Folio),
            folio: cedula.Folio,
            enviar: false
          };
          this.cedulasAEnviar.push(cedulaAEnviar);
        });
      },
      elegirAnchoCeldaAcciones: function() { 
        let ancho = ''
        try {
          let numeroAcciones = Object.values(this.accionesEnTabla).filter(a => a == true).length;
          if(numeroAcciones == 3)
            ancho = (this.accionesEnTabla.constituir == true) ? 'width: 180px;' : 'width: 80px;'; 
          else if(numeroAcciones == 4)
            ancho = (this.accionesEnTabla.constituir == true) ? 'width: 210px;' : 'width: 110px;';
          else if(numeroAcciones == 5)
            ancho = (this.accionesEnTabla.constituir == true) ? 'width: 230px;' : 'width: 130px;';
        }
        catch(exc) {

        }
        return ancho;
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
    },
    computed: {
      obtenerPaginacionDeCedulas() {
        return this.paginacionDeCedulas(this.listaDeCedulas);
      },
      // modificacion
      numeroPaginasMostrar() {
        return this.paginacionTmp;
      }
    },
    watch: {
      listaDeCedulas() {
        this.obtenerNumeroDePaginas();
      },
      limpiarSeleccionarTodo() {
        if(this.limpiarSeleccionarTodo)
          this.$nextTick(() => {
            this.seleccionarTodo = false;
            $("#" + this.idDelInput + 'seleccionarTodos').prop('checked', false);
          });
      },     
      '$store.state.Login_Usuario.Area': function() {                      
          this.datosUsuario(this.$store.state.Login_Usuario.Area);          
      }    
    },
    mounted() {
      if(this.conResponsive) {
        const TAMANO_INICIAL = $(window).width();
        this.mostrarLayoutCardView = (TAMANO_INICIAL <= 900);
        $(window).resize(() => {
            const TAMANO_INICIAL = $(window).width();
            this.mostrarLayoutCardView = (TAMANO_INICIAL <= 900);
            this.$nextTick(() => {
              this.mostrarEstadoCheckbox();
              if(this.radioSeleccionado != null)
                this.mostrarEstadoRadio({ idElemento: this.radioSeleccionado.Folio });
            });
        });
      }
    },
    created() {
      //console.log('encabezadosColumnas::',this.encabezadosColumnas);
      //console.log('acciones::',this.accionesEnTabla)
      this.datosUsuario(this.$store.state.Login_Usuario.Area); 
      this.obtenerNumeroDePaginas();      
      // si el componente 
      if(this.listaCedulasSeleccionadas != null && this.listaCedulasSeleccionadas.length > 0) {
        this.listaCedulasSeleccionadas.forEach(cs => { 
          this.cedulasAEnviar.forEach(ce => {
            if(ce.folio == cs.NotificadorId || ce.folio == cs.Folio) {
              ce.enviar = true;
            }
          });
        });
        this.$nextTick(() => {
          this.mostrarEstadoCheckbox();
          if(this.radioSeleccionado != null)
            this.mostrarEstadoRadio({ idElemento: this.radioSeleccionado.Folio });
        });
      }
    },
  }
</script>
<style scoped>
  .resaltar-fila {
    background-color: rgb(168, 91, 91);
    color: white;
  }

  #dimensiones-pantalla-tmp {
      display: inline-block;
      content: '';
      width: 1px;
      height: 1px;
      overflow: hidden;
  }

  @media screen and (min-width: 900px) {
      #dimensiones-pantalla-tmp {
          display: none;
      }
  }

  .scroll-horizontal {
     overflow-x: scroll;
    overflow-y: hidden;
    height: 80px;
    white-space:nowrap;
  }
  
  .fila-card-layout {
    border: 1px solid #969696;
    font-size: 2vmin;
  }

  .padding-fila-card-layout {
    padding: 1vmin 1vmin 1vmin 1vmin;
  }

  .ocultar-columna {
    color: #22262e !important;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Chrome, Edge, Opera and Firefox */
  }

  #encabezados-card-view {
    /* border: 1px solid #969696; */
    background-color:#22262e;
    color: white;
    font-weight: bold;
  }

  #columnas-card-view {
    /* border: 1px solid #969696; */
    background-color:#adaeaf;
    color: black;
  }

  .contenido-listado {
    border-collapse: collapse;
    width: 100%;
    background-color: #26272b;
  }

  .acciones-sm {
    width: 10% !important;
  }

  .acciones-md {
    width: 6em !important;
  }

  .acciones-lg {
    width: 100% !important;
  }

  .encabezados-listado {
    position: sticky;
    top: 0;
    background: #5c5959;
    border: 1;
  }

  #paginacion-tabla {
    padding: 0;
  }

  .pagination > li > button:focus {
    color: white;
    background-color: #3c3d41;
    border-color: black;
    box-shadow: none;
  }

  .pagination > .active > button {
    color: white;
    background-color: #3c3d41;
    border-color: black;
    box-shadow: none;
  }

  .pagina-seleccionada {
    color: white;
    background-color: #3c3d41;
    border-color: black;
    box-shadow: none;
  }

  .pagination > li > button {
    color: white;
    background-color: grey;
    border-color: black;
  }

    .pagination > li > button[id^="opcion"] {
      color: white;
      background-color: #26272b;
      border-color: black;
    }

  .pagination {
    margin: 0px !important;
  }

  .btn-sm {
    width: 25px;
    height: 25px;
    padding: 0;
    cursor: pointer;
  }

  .eliminar:hover,
  .eliminar:focus {
    border-color: rgb(156, 29, 29);
    background-color: rgb(156, 29, 29);
    color: white;
  }

  .editar:hover,
  .editar:focus {
    border-color: rgb(25, 111, 145);
    background-color: rgb(25, 111, 145);
    color: white;
  }

  .base:hover,
  .base:focus {
    border-color: rgb(53, 53, 53);
    background-color: rgb(53, 53, 53);
    color: white;
  }

  .btn-primary {
    background-color: #ececec;
    color: rgb(32, 32, 32);
    border: 1px solid rgb(32, 32, 32);
  }

  #celda-acciones .btn {
    padding-right: 10px;
    padding-left: 10px;    
  }

  td,th {
    font-size : 1.7vmin;
  }

  th {
    color: white !important;
  }

  td {
    color: black;
    border-top: 1px solid #c5c5c5;
    background-color: #b6b6b6;
  }

  
</style>





// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CTablaGenericaCedulas.vue